import React, { useEffect, useRef } from "react";
import "./StepContainer.css";

interface StepContainerProps {
  children: React.ReactNode;
  direction: "forward" | "backward";
  isActive: boolean;
}

export const StepContainer: React.FC<StepContainerProps> = ({
  children,
  direction,
  isActive,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isActive && containerRef.current) {
      // Focus management for accessibility
      const firstFocusable = containerRef.current.querySelector(
        'input, button, select, textarea, [tabindex]:not([tabindex="-1"])'
      ) as HTMLElement;
      if (firstFocusable) {
        firstFocusable.focus();
      } else {
        containerRef.current.focus();
      }
    }
  }, [isActive]);

  if (!isActive) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className={`step-container step-container-${direction}`}
      role="region"
      aria-live="polite"
      tabIndex={-1}
    >
      {children}
    </div>
  );
};

